module.exports = __webpack_public_path__ + "static/media/CoverImage.7efb27bf.svg";